import { render } from "./FileInput.vue?vue&type=template&id=5aefada7"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/laravel/helpdeskada/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__